import {CollectionFactory, Reducer} from '@modifi/redux'
import {getAuthenticatedThemisClient, StateView} from '@modifi/onboarding-api-clients'

import {AppThunkAction} from '../../types/redux'

const apiClient = getAuthenticatedThemisClient()

const {actions, selectors, reducer} = CollectionFactory({
  actionNamePrefix: 'data/states/collection',
  reducerPath: ['data', 'addressStates', 'collection'],
  fetchRequest: (state, {countryCode}) =>
    apiClient.Countries.getStatesByCountryCode({countryCode: countryCode?.toUpperCase()})?.then(
      res => res?.data()?.states || []
    ),
  entityPrimaryKeySelector: entity => entity?.id!,
})

export const selectStatesByCountryCode = (
  state: Record<string, any>,
  countryCode: string
): StateView[] => selectors?.selectByKeyWindow(state, {countryCode: countryCode?.toUpperCase()})

export default reducer as Reducer

export const aFetchStatesByCountryCode = (countryCode: string): AppThunkAction =>
  actions!.fetch({countryCode})
